import React from 'react';
import { ReactComponent as PlaceholderBreadCrumb } from '../../images/placeholder-breadcrumbs.svg';
import { ReactComponent as PlaceholderHotkey } from '../../images/placeholder-hotkeys.svg';
import { BreadcrumbPlaceholder, HotkeysPlaceholder, TaggingFlowPlaceholderWrapper, Text } from './TaggingFlowPlaceholderStyles';

export const TaggingFlowPlaceholder: React.FC = () => {
  return (
    <TaggingFlowPlaceholderWrapper>
      <BreadcrumbPlaceholder>
        <PlaceholderBreadCrumb />
        <Text>Follow your tagging progress and easily edit by clicking the text</Text>
      </BreadcrumbPlaceholder>
      <HotkeysPlaceholder>
        <PlaceholderHotkey />
        <Text>Use the recommendations and hotkeys to tag efficiently</Text>
      </HotkeysPlaceholder>
    </TaggingFlowPlaceholderWrapper>
  );
};
